import { useEffect, useState } from "react"
import Text from "../Base/Text"
import util from "../../utils/util"
import Block from "../Base/Block";

const Price = (prop: {
    value?: string,
    size?: number,
    color?: string,
    bold?: boolean,
    del?: boolean,
    scale?: boolean,
    style?: React.CSSProperties,
})=>{

    const [valueList, setValueList] = useState<{isIcon: boolean, text: string}[]>([]);
    const size = prop.size || 30;
    const color = prop.color || '';
    const scale = typeof prop.scale !== 'undefined' ? prop.scale : true;
    const style = prop.style || '';
    const {del, bold} = prop;

    useEffect(()=>{
        if (prop.value && !util.isEmpty(prop.value)) {
            var strs = prop.value.split('¥')
            var result = []
            if (strs[0].length > 0) {
              result.push({
                isIcon: false,
                text: strs[0],
              })
            }
            if (strs.length > 1) {
              for (var i = 1; i < strs.length; i++) {
                result.push({
                  isIcon: true,
                  text: '¥',
                })
                if (strs[i].length > 0) {
                  result.push({
                    isIcon: false,
                    text: strs[i],
                  })
                }
              }
            }
            setValueList(result);
          }
    }, [prop.value])

    return <>
    {valueList?.map((item, index) => {
        return (
          <Block key={`${index}`}>
            <Text
              style={
            {
                textDecoration: del ? 'line-through':'unset',
                color: color.length > 0 ? color : '#e74737',
                fontSize: `${size / 30}rem`,
                fontWeight: bold ? 'bold':'normal'
            }
              }
            >
              {item.isIcon ? (
                <Text
                  style={{
                    // fontSize: `${(scale ? size * 0.67 : size) / 40}rem`,
                    transform:"scale(0.7)",
                    top: `${size * 0.06}px`,
                    display:"inline-block",
                    position:"relative",
                    marginRight: '0.075rem',
                    ...(prop.style || {})
                  }}
                  className="product-price-icon"
                >
                  {item.text}
                </Text>
              ) : (
                <Text className="product-price-value" style={{
                  color: color.length > 0 ? color : '#e74737',
                }}>{item.text}</Text>
              )}
            </Text>
          </Block>
        )
      })}
    </>
}

export default Price;